import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

import type {
  NotificationLikeResponse,
  NotificationReactionRequest,
  NotificationReadResponse,
  UserNotificationResult,
} from './notifications.types';

export const userNotificationsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserNotifications: builder.query<ApiResponse<UserNotificationResult>, void>({
      query: () => '/notifications',
      providesTags: [RTKQueryTag.Notifications],
    }),
    updateReadNotifications: builder.mutation<unknown, void>({
      query: () => ({
        method: 'POST',
        url: '/notifications/read',
      }),
      invalidatesTags: [RTKQueryTag.Notifications],
    }),
    likeNotification: builder.mutation<ApiResponse<NotificationLikeResponse>, NotificationReactionRequest>({
      query: ({ notificationId }) => ({
        method: 'POST',
        url: '/notifications/like',
        body: { notificationId },
      }),
      invalidatesTags: [RTKQueryTag.Notifications],
    }),
    unlikeNotification: builder.mutation<ApiResponse<NotificationLikeResponse>, NotificationReactionRequest>({
      query: ({ notificationId }) => ({
        method: 'DELETE',
        url: '/notifications/like',
        body: { notificationId },
      }),
      invalidatesTags: [RTKQueryTag.Notifications],
    }),
    markNotificationAsRead: builder.mutation<ApiResponse<NotificationReadResponse>, NotificationReactionRequest>({
      query: ({ notificationId }) => ({
        method: 'POST',
        url: '/notifications/read',
        body: { notificationId },
      }),
      invalidatesTags: [RTKQueryTag.Notifications],
    }),
  }),
});

export const {
  useGetUserNotificationsQuery,
  useUpdateReadNotificationsMutation,
  useLikeNotificationMutation,
  useUnlikeNotificationMutation,
  useMarkNotificationAsReadMutation,
} = userNotificationsSlice;
